import axios from 'axios';
import { getStoredAuthToken, getStoredOrgId, clearStoredSession } from '../shared/authSession';
import { userApiBase } from './runtimeConfig';

const apiClient = axios.create({
    baseURL: userApiBase,
    timeout: 30000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

const generateTraceId = () => {
    return 'trace-' + Math.random().toString(36).substring(2, 15);
};
const generateCorrelationId = () => {
    return 'corr-' + Math.random().toString(36).substring(2, 15);
};

// Request Interceptor for adding the headers
apiClient.interceptors.request.use(
    (config) => {
        const url = config.url || '';
        const isAuthEndpoint = url.includes('/v1/auth/login') ||
            url.includes('/v1/auth/register') ||
            url.includes('/v1/auth/signup') ||
            url.includes('/v1/auth/sso/') ||
            url.includes('/v1/auth/password/');

        const token = getStoredAuthToken();
        if (token && !isAuthEndpoint) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete config.headers.Authorization;
        }
        config.headers['x-trace-id'] = generateTraceId();
        config.headers['language-id'] = 'en';
        const orgId = getStoredOrgId();
        if (orgId && orgId !== "null" && orgId !== "undefined") {
            config.headers['x-tenant-id'] = orgId;
        } else {
            delete config.headers['x-tenant-id'];
        }
        config.headers['x-correlation-id'] = generateCorrelationId();

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor for handling errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error('API Error:', error);
        // Maintenance mode check: Only redirect if online and server responded with 503 (Service Unavailable)
        if (navigator.onLine && error.response && error.response.status === 503) {
            if (window.location.pathname !== '/maintenance.html') {
                window.location.href = '/maintenance.html';
            }
        }
        if (error.response && error.response.status === 401) {
            clearStoredSession();
            if (window.location.pathname !== '/sign-in') {
                window.location.href = '/sign-in';
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
